module.exports = __webpack_public_path__ + "img/top_primebnr_sp.7eb081f1.png";